var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"icon",style:(_vm.extraStyling)},[_c('use',{attrs:{"xlink:href":_vm.id}})])
}
var staticRenderFns = []

export { render, staticRenderFns }